import axiosInstance from '../components/apiService';

const getAll = () => {
  return axiosInstance.get("porudzbine");
};

const getAllActiveIndents = (page = 0, size = 50, sortBy = 'creationTime', sortDir = 'desc') => {
  return axiosInstance.get("porudzbine/aktivnePorudzbine", {
    params: { page, size, sortBy, sortDir }
  });
};

const getAllInactiveIndents = (page = 0, size = 50, sortBy = 'creationTime', sortDir = 'desc') => {
  return axiosInstance.get("porudzbine/neaktivnePorudzbine", {
    params: { page, size, sortBy, sortDir }
  });
};

const getAllIndents = (page = 0, size = 50, sortBy = 'creationTime', sortDir = 'desc') => {
  return axiosInstance.get("porudzbine/svePorudzbine", {
    params: { page, size, sortBy, sortDir }
  });
};

const get = (id) => {
  return axiosInstance.get(`porudzbine/${id}`);
};

const create = (indent, clientLegalName) => {
  return axiosInstance.post("porudzbine", indent, {
    params: {
      clientLegalName: clientLegalName,
    },
  })
  .then(response => {
    return response.data;
  })
  .catch(error => {
    throw new Error("Client with that legal name not found");
  });
};

const update = (id, data) => {
  return axiosInstance.put(`porudzbine/${id}`, data);
};

const remove = (indentCode) => {
  return axiosInstance.delete(`porudzbine/${indentCode}`);
};

const activateIndent = (indentCode) => {
  return axiosInstance.put("porudzbine/aktiviraj", indentCode);
};  

const confirmIndentDelivery = (indentCode) => {
  return axiosInstance.put("porudzbine/potvrdiIsporuku", indentCode);
};

const removeAll = () => {
  return axiosInstance.delete("porudzbine");
};

const findByCode = (code) => {
  return axiosInstance.get("porudzbine/pretragaPrekoSifrePorudzbine", {
    params: {
      indentCode: code,
    },
  });
};

const findByCustomerName = (customerName) => {
  return axiosInstance.get("porudzbine/pretragaPrekoImenaKupca", {
    params: {
      customerName: customerName,
    },
  });
};

const getActiveIndentsByCustomerName = (customerName) => {
  return axiosInstance.get("porudzbine/aktivnePorudzbineKupca", {
    params: {
      customerName: customerName,
    },
  });
};

const getPendingIndentsByCustomerName = (customerName) => {
  return axiosInstance.get("porudzbine/porudzbineNaCekanjuKupca", {
    params: {
      customerName: customerName,
    },
  });
};

const search = (params) => {
  return axiosInstance.get("porudzbine/pretraga", {
    params,
    paramsSerializer: {
      serialize: (p) => {
        const parts = [];
        Object.entries(p).forEach(([key, val]) => {
          if (Array.isArray(val)) {
            val.forEach((v) => parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`));
          } else {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
          }
        });
        return parts.join("&");
      },
    },
  });
};

const IndentService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  activateIndent,
  findByCode,
  confirmIndentDelivery,
  getAllActiveIndents,
  getAllInactiveIndents,
  getAllIndents,
  findByCustomerName,
  getActiveIndentsByCustomerName,
  getPendingIndentsByCustomerName,
  search
};

export default IndentService;
